import { httpClient } from '@/services/http/httpClient'

type DisponibilityToken = {
  expireIn: string
  id: string
  token: string | null
  token_type: string
  total_amount: number
  total_used: number
  userId: string
  isValid: boolean
}

type TokenHttpResponse = {
  disponibilityToken: DisponibilityToken
}

type GetInvitationLinkResponse = {
  totalUsers: number
  totalUsed: number
  expireIn: string
  isValid: boolean
  token: string | null
}

export async function getInvitationLink(): Promise<GetInvitationLinkResponse> {
  const { data } = await httpClient.get<TokenHttpResponse>(
    '/users/register-tokens',
  )

  return {
    totalUsers: data.disponibilityToken.total_amount,
    totalUsed: data.disponibilityToken.total_used,
    expireIn: data.disponibilityToken.expireIn,
    isValid: data.disponibilityToken.isValid,
    token: data.disponibilityToken.token,
  }
}
